import { purchaseOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createPurchaseOrder = {
  name: "createPurchaseOrder" as const,
  input: z.object({}),
  output: z.object({ purchaseOrderId: purchaseOrderIdFormat.schema }),
};
